import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import DisciplineAccessControl from '../common/DisciplineAccessControl';

const HighMastDashboard = () => {
  const { user } = useAuth();
  const theme = useTheme();

  // Check if user has organization-wide access
  const hasOrgWideAccess = user?.permissionScope !== 'network_section';

  return (
    <DisciplineAccessControl requiredDiscipline="Vertical Asset">
    <Box sx={{ maxWidth: '100%' }}>
      {/* High Mast Summary Section */}
      <Typography
        variant="h5"
        sx={{
          mb: 2,
          fontWeight: 600,
          fontSize: { xs: '1.25rem', md: '1.5rem' }
        }}
      >
        High Mast Infrastructure Overview
      </Typography>

      {hasOrgWideAccess ? (
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
          gap: 3,
          mb: 3
        }}>
          {/* Future: Case Summary */}
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
              border: '2px dashed',
              borderColor: 'divider',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '300px',
              backgroundColor: 'background.paper'
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Case Summary
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Total open cases, overdue count,
                <br />
                approaching SLA, and
                <br />
                closed cases overview
              </Typography>
            </Box>
          </Box>

          {/* Future: SLA Monitoring */}
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
              border: '2px dashed',
              borderColor: 'divider',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '300px',
              backgroundColor: 'background.paper'
            }}
          >
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                SLA Monitoring
              </Typography>
              <Typography variant="caption" color="text.secondary">
                SLA compliance tracking,
                <br />
                overdue case alerts, and
                <br />
                resolution time metrics
              </Typography>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            p: 4,
            borderRadius: 2,
            boxShadow: theme.shadows[1],
            textAlign: 'center',
            backgroundColor: 'background.paper',
            border: '2px dashed',
            borderColor: 'divider'
          }}
        >
          <Typography variant="h6" sx={{ mb: 2, color: 'text.secondary' }}>
            Access Restricted
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 500, mx: 'auto' }}>
            High Mast dashboard requires organization-wide access permissions.
            Please contact your administrator to upgrade your access level.
          </Typography>
        </Box>
      )}

      {/* Future sections */}
      <Typography
        variant="h5"
        sx={{
          mb: 2,
          mt: 4,
          fontWeight: 600,
          fontSize: { xs: '1.25rem', md: '1.5rem' }
        }}
      >
        High Mast Analytics & Monitoring
      </Typography>

      <Box sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
        gap: 3,
        mb: 3
      }}>
        {/* Future: Defect Detection Summary */}
        <Box
          sx={{
            p: 3,
            borderRadius: 2,
            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
            border: '2px dashed',
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '400px',
            backgroundColor: 'background.paper'
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              AI Defect Detection Summary
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Defect distribution by type,
              <br />
              severity breakdown, and
              <br />
              detection confidence metrics
            </Typography>
          </Box>
        </Box>

        {/* Future: Inspection Timeline */}
        <Box
          sx={{
            p: 3,
            borderRadius: 2,
            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.05)',
            border: '2px dashed',
            borderColor: 'divider',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '400px',
            backgroundColor: 'background.paper'
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Inspection & Maintenance
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Scheduled inspection timelines,
              <br />
              UAV imagery processing status, and
              <br />
              maintenance activity tracking
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
    </DisciplineAccessControl>
  );
};

export default HighMastDashboard;
